<!--
 - Author : wanghongling.
 - Date   : 2020/06/22.
 - File   : line.横向柱状图
 -->

<template>
  <div :id="id" :style="{width: radarList.width, height: radarList.height}">
  </div>
</template>

<script>
  export default {
    name: 'air-AQI',
    data() {
      return {
        myAQI: null
      }
    },
    props: {
      id: {
        type: String,
        default: 'test11'
      },
      radarList: {
        default: {
          width: '380px', //宽度
          height: '240px', // 高度
          data: [768, 456, 372, 251, 235, 142, 81],
          titlename: ['正常短假', '特殊短假', '正常长假', '特殊长假', '婚假', '产假', '丧假'],
          myColor: ['#76a7de', '#ef41ff', '#f8b048', '#40e6f0', '#f780b8', '#2efd9e', '#e65710'] // 颜色
        }
      }
    },
    watch: {
      lineList: {
        handler() {
          this.$nextTick(() => {
            this.makeAQI()
          })
        },
        deep: true
      }
    },
    mounted() {
      this.init()
    },
    destroyed() {
      this.$echarts.dispose(this.myAQI)
      // window.removeEventListener('resize', this.resizeEvent)
      this.myAQI = null
    },
    methods: {
      /**
       * 初始化echart
       * @author: wanghongling
       * @createDate: 2019/8/9
       * @return {Object}
       */
      init() {
        this.myAQI = this.$echarts.init(document.getElementById(this.id))
        this.makeAQI()
      },
      calMax(arr) {
        let max = 0
        arr.forEach(el => {
          el.forEach(el1 => {
            if (!(el1 === undefined || el1 === '')) {
              if (max < el1) {
                max = el1;
              }
            }
          })
        })
        // let maxint = Math.ceil(max / 9.5)
        //不让最高的值超过最上面的刻度
        // let maxval = maxint * 12
        //让显示的刻度是整数
        // console.log(max, maxint, 'maxval')
        let maxval = Math.ceil(max)
        return maxval
      },
      /**
       * echart赋值
       * @author: wanghongling
       * @createDate: 2019/8/9
       * @return {Object}
       */
      makeAQI() {
        var data = this.radarList.data
        let sum = data.reduce((pre, item) => pre + item, 0)
        var data2 = []
        let margin = 110
        let max = Math.ceil(this.calMax([data]) / 10) * 10
        // if(this.radarList.type) {
        //   margin = 0
        //   data2 = data.map(() => {
        //     return sum+150
        //   })
        // }
        data2 = new Array(data.length).fill(max)
        // let titlename = this.radarList.titlename
        let myColor = this.radarList.myColor
        let that = this
        let option = {
          grid: {
            left: this.radarList.gridLeft || '0%',
            right: this.radarList.gridRight || '5%',
            bottom: this.radarList.gridBottom || '0%',
            top: this.radarList.gridTop || '10%',
            containLabel: true
          },
          xAxis: {
            show: false
          },
          yAxis: [
            {
              show: true,
              data: this.radarList.titlename,
              inverse: true,
              axisLine: {
                show: false
              },
              splitLine: {
                show: false
              },
              axisTick: {
                show: false
              },
              axisLabel: {
                color: '#25c3b6',
                align: 'left',
                margin: margin,
                formatter: function(value, index) {
                  if(that.radarList.type) {
                    return '{title1|' + value + '} '
                  } else {
                    return [
                      // '{lg|' + (index + 1) + '}' + '{title|' + value + '}'
                      '{title|' + (index + 1) + '     ' + value + '}'
                    ].join('\n')
                  }
                },
                rich: {
                  lg: {
                    color: '#0aaade',
                    fontSize: 14,
                    padding: [0, 10, 0, 0]
                  },
                  title: {
                    color: '#0aaade',
                    fontSize: 14
                  },
                  title1: {
                    color: '#fff',
                    fontSize: 18,
                    padding: [50, 10, 0, 0]
                  }
                }
              }
            },
            {
              show: true,
              inverse: true,
              data: data,
              axisLabel: {
                textStyle: {
                  fontSize: 16,
                  color: '#fff'
                },
                formatter: function(value) {
                  if(that.radarList.type) {
                    return '{title|'+((value / sum * 10000) / 100.00).toFixed(2) + '%}';
                  } else {
                    return value + '{dw|' + that.radarList.dw + '}';
                  }
                },
                rich: {
                  title: {
                    color: '#fff',
                    fontSize: 18
                  },
                  dw: {
                    color: '#56626a',
                    padding: [0, 0, 0, 5],
                    fontSize: 14
                  }
                }
              },
              axisLine: {
                show: false
              },
              splitLine: {
                show: false
              },
              axisTick: {
                show: false
              }
            }
          ],
          series: [
            {
              name: '条',
              type: 'bar',
              yAxisIndex: 0,
              data: data,
              barWidth: this.radarList.barWidth || 12,
              itemStyle: {
                normal: {
                  barBorderRadius: 30,
                  color: function(params) {
                    var num = myColor.length;
                    return myColor[params.dataIndex % num]
                  }
                }
              },
              label: {
                normal: {
                  show: false,
                  position: 'inside',
                  formatter: '{c}%'
                }
              },
              animationDuration: 4000,
              animationDurationUpdate: 400,
              animationEasing: 'cubicIn',
              animationDelay: function (idx) {
                return idx * 280 + 100
              }
            },
            {
              name: '外框',
              type: 'bar',
              itemStyle: {
                normal: {
                  barBorderRadius: 30,
                  color: '#021625'
                }
              },
              barGap: '-100%',
              z: 0,
              barWidth: this.radarList.barWidth || 12,
              data: data2,
              animationDuration: 3000,
              animationDurationUpdate: 400,
              animationEasing: 'cubicIn',
              animationDelay: function (idx) {
                return idx * 280 + 100
              }
            }
          ]
        }
        this.myAQI.setOption(option)
      },
      /**
       * echart图表适应
       * @author: wanghongling
       * @createDate: 2019/8/9
       * @return {Object}
       */
      resizeEvent() {
        this.myAQI.resize() // 使图表适应
      }
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/echarts/airAQI.vue